<template>
  <div>
    <b-button class="typo-butt-add mt-3 mr-1 but-add" @click="openNewZone">
      <i class="fas fa fa-1x fa-plus mr-2"></i>
      {{$t("zone.add_zone")}}
    </b-button>

    <!-- Crea nuova zona Modal-->
    <b-modal
      ref="modal"
      size="lg"
      :id="'modal-new-zone'+this._uid"
      :saveSubmit="saveSubmit"
      :title="$t('zone.modal_title')"
      :ok-title="$t('user_modal.button_save')"
      :cancel-title="$t('user_modal.button_cancel')"
      @ok="handleOk"
    >
      <b-row>
        <b-col cols="9">       
          <!--input name of zone -->
          <b-form-group class="ml-2">
            <label class="typo-label">{{$t("zone.label_zone_name")}}</label>
            <b-form-input
              v-model="zoneName"
              type="text"
              :state="validation_zoneName"
            ></b-form-input>
            <b-form-invalid-feedback
              :state="validation_zoneName"
            >{{$t("signup.validation_null")}}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'; 
import * as consts from '../constants.js';


export default {
  name: "AddZone",
  components:{
  },
  data() {
    return {
     zoneName: "",
     saveSubmit: "false",
     plantId:"",
    };
  },
   props: {
    zoneId: null,
    tableBtData: null,
  },
  computed: {
    validation_zoneName() {
      if (this.saveSubmit == true) return this.zoneName.length > 0;
    },

  },
  mounted() {
        console.log("addZone mounted", this.$store.state.plantCollections);
        
  },

  methods: {
    openNewZone(bvModalEvt) {
      if (this.tableBtData.length >= consts.MAX_NUMBER_OF_ZONES) {
        this.$bvModal.msgBoxOk(this.$t("zone.no_more_zones"), {
          title: this.$t("zone.warning"),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: "danger",
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
      });
      } else {
        this.$bvModal.show('modal-new-zone'+this._uid);
      }
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveSubmit = true;
      // Trigger submit handler
      this.saveZone();
    },

    saveZone() {     
      if (!this.validation_zoneName) return; 
      var maxId = 0;
      this.tableBtData.forEach( (x) => {
        if (x.zoneNumber > maxId) maxId = x.zoneNumber;
      });
      this.$store.dispatch("dbSaveZone", {
        bleLamps: [],
        collections: [],
        groups: [],
        plantId: this.$store.state.currentPlant.id,
        scenes: [],          
        zoneId: "" + uuid.v1(),
        zoneName: this.zoneName,
        zoneNumber: maxId + 1
      });

      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
    }
  }
};
</script>
